import { computed, inject, Injectable, signal } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../../modules/shared/store/common/component-store-v2.factory';
import { globalStore } from '../../../../../modules/shared/shared.global-service';
import { selectWorkRecordDate } from '../../../../../modules/content/store/service/service.selectors';
import {
    WorkDataSuggestionEvaluationObject,
} from '@libs/types/src/services/object-type/work/work-data-suggestion-evaluation.object';
import { localDate } from '../../../../../modules/shared/pipes/local-date.pipe';
import { SessionService } from '../../../../../services/session.service';
import { formatPerson } from '@libs/shared/helpers/person.utils';

export type WorkDataSuggestionEvaluationRecord = WorkDataSuggestionEvaluationObject & {
    index: number;
    key: string;
};

@Injectable()
export class WorkSuggestionPageStore extends ComponentStoreV2Factory {

    protected readonly session = inject(SessionService);

    public workDate = globalStore!.selectSignal(selectWorkRecordDate);

    public folder = computed(() => {
        return this.data.getFolderByPerson();
    });

    public readonly evaluations = signal<WorkDataSuggestionEvaluationObject[]>([]);

    public evaluationRecords = computed<WorkDataSuggestionEvaluationRecord[]>(() => {
        return this.evaluations().map((item, index) => {
            const evaluationDateFormatted = localDate(item.evaluationDate, this.session) as string | null;
            return {
                ...item,
                evaluationDateFormatted,
                index,
                key: evaluationDateFormatted + ' ' + formatPerson(item.savedBy),
            };
        });
    });

}
